export default __webpack_public_path__ + "static/media/9.473e17e2.jpg";